import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  destroyPackageGroup: ({ container_id, package_group_id }) => {
    return RequesterV1.delete(
      `/packing_house/production/uniq_final_packing_list/show_container/container/${container_id}/destroy_package_group/${package_group_id}`
    );
  },
  container({ container_id }) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/container/${container_id}`
    );
  },
  fetchPackingHouseProcesses(packing_house_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/list_processes/" + packing_house_id
    );
  },
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/list_containers/fetch_packing_house_process/" + packing_house_process_id
    );
  },
  fetchContainers(agro_exporter_process_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/show_containers/" +
        agro_exporter_process_id
    );
  },
  fetchPackageGroup({ container_id, package_group_id }) {
    return RequesterV1.get(
      `/packing_house/production/uniq_final_packing_list/edit_package_group/container/${container_id}/package_group/${package_group_id}`
    );
  },
  fetchCropSizes(agro_exporter_process_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/show_container/list_exporter_process_crop_sizes/" +
        agro_exporter_process_id
    );
  },
  fetchPackingListFormats(container_id) {
    return RequesterV1.get(
      "packing_house/production/uniq_final_packing_list/show_container/fetch_packing_list_formats/" +
      container_id
    );
  },
  downloadFormatXlsx(container_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/download_format_xlsx/${container_id}`,
      { responseType: "blob" }
    );
  },
  downloadPackingListXlsx(container_id, packing_list_format_id) {
    return RequesterV1.get(
      `packing_house/production/uniq_final_packing_list/show_container/download_packing_list_xlsx/${container_id}/${packing_list_format_id}`,
      { responseType: "blob" }
    );
  }
};
